var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmilePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 10.9993V11.9993C21.9898 14.0177 21.3691 15.9857 20.2196 17.6447C19.0701 19.3037 17.4454 20.576 15.5592 21.2944C13.6731 22.0128 11.6137 22.1436 9.65175 21.6696C7.68984 21.1956 5.91727 20.1391 4.56707 18.6389C3.21686 17.1386 2.35223 15.265 2.08684 13.2641C1.82144 11.2633 2.1677 9.22902 3.08011 7.42868C3.99251 5.62833 5.42835 4.14622 7.19885 3.17718C8.96935 2.20814 10.9917 1.79753 12.9999 1.99934M8 13.9994C8 13.9994 9.5 15.9994 12 15.9994C14.5 15.9994 16 13.9994 16 13.9994M9 8.99939H9.01M15 8.99939H15.01M16 4.99939H22M19 1.99939V7.99939",
    stroke: "#101010",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilePlusIcon);
export default __webpack_public_path__ + "static/media/smile-plus-icon.97da8369257b7a31e382ab63ab311d89.svg";
export { ForwardRef as ReactComponent };